import SettingEmail from './SettingEmail';

export default SettingEmail;



// WEBPACK FOOTER //
// ./src/components/settings/SettingEmail/index.js